import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft'
import { ActionIcon, Flex, Title } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Badge, Icon } from '@flecto/ui'

import { useInsuranceManagerContext } from '../../../../provider'
import { EKindTab, useInsuranceManagerState } from '../../../../state'
import classes from './styles.module.css'

export function Header() {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_sidebar' })
  const { tab, setTab } = useInsuranceManagerState()
  const { countInsurances } = useInsuranceManagerContext()

  if (tab === EKindTab.ISSUES) {
    return (
      <Flex p='md' gap='sm' className={classes.header} align='center'>
        <ActionIcon
          onClick={() => setTab(EKindTab.GENERAL)}
          variant='light'
          size='sm'
        >
          <Icon icon={faChevronLeft} />
        </ActionIcon>
        <Title order={4}>{t('insurances_modal.issued_policies')}</Title>
        <Badge>
          {t('insurances_modal.issued_policies_qty', {
            count: countInsurances,
          })}
        </Badge>
      </Flex>
    )
  }

  return (
    <Flex p='md' className={classes.header}>
      <Title order={4}>{t('insurances_modal.title')}</Title>
    </Flex>
  )
}
